import React, { useState } from "react";
import { ArrowRight, Heart, Home, Radio, Trash2, Zap } from "lucide-react";

function formatAgo(iso) {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 45) return "Just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 172800) return "Yesterday";
  return `${Math.floor(s / 86400)}d ago`;
}

const FollowingBetHouseLiveActivityCard = ({
  item,
  unread,
  onMarkRead,
  onViewHouse,
  onDelete,
}) => {
  const md = item?.metadata || {};
  const houseName = md.houseName || "Bet house";
  const ownerName = md.ownerName || "Operator";
  const pool = Number(md.amountAvailable) || 0;
  const coverImage = md.coverImage || "";

  const [coverFailed, setCoverFailed] = useState(false);

  return (
    <article
      className={`act-follow-house ${unread ? "act-follow-house-unread" : ""}`}
      onClick={() => unread && onMarkRead?.(item._id)}
      onKeyDown={(e) => {
        if (e.key === "Enter" && unread) onMarkRead?.(item._id);
      }}
      role="button"
      tabIndex={0}
    >
      <div className="act-follow-house-stripe" aria-hidden />

      <div className="act-follow-house-inner">
        <div className="act-follow-house-head">
          <span className="act-follow-house-badge">
            <Heart size={10} aria-hidden />
            Following
          </span>
          <span className="act-follow-house-live">
            <Radio size={9} aria-hidden />
            Live
          </span>
          <span className="act-follow-house-time">{formatAgo(item.createdAt)}</span>
        </div>

        <div className="act-follow-house-hero">
          <div className="act-follow-house-cover-wrap">
            {coverImage && !coverFailed ? (
              <img
                className="act-follow-house-cover"
                src={coverImage}
                alt=""
                width={42}
                height={42}
                onError={() => setCoverFailed(true)}
              />
            ) : (
              <span className="act-follow-house-cover act-follow-house-cover-fallback">
                <Home size={18} aria-hidden />
              </span>
            )}
            <span className="act-follow-house-cover-dot" aria-hidden>
              <Zap size={8} />
            </span>
          </div>

          <div className="act-follow-house-copy">
            <h3 className="act-follow-house-title">
              <span className="act-follow-house-name">{houseName}</span>
              {" is now live"}
            </h3>
            <p className="act-follow-house-sub">{ownerName} opened the floor</p>
          </div>

          {unread ? <span className="act-row-dot" aria-label="Unread" /> : null}
        </div>

        <div className="act-follow-house-details">
          <div className="act-follow-house-pool">
            <span className="act-follow-house-pool-label">Pool</span>
            <span className="act-follow-house-pool-text">
              {pool > 0 ? `${pool.toLocaleString()} cash available` : "Ready for bettors"}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="act-follow-house-cta"
          onClick={(e) => {
            e.stopPropagation();
            onViewHouse?.(item);
          }}
        >
          <span>View house</span>
          <ArrowRight size={12} aria-hidden />
        </button>
      </div>

      <button
        type="button"
        className="act-row-delete"
        aria-label="Remove activity"
        onClick={(e) => {
          e.stopPropagation();
          onDelete?.(item._id);
        }}
      >
        <Trash2 size={14} />
      </button>
    </article>
  );
};

export default FollowingBetHouseLiveActivityCard;
